import { useMutation } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import { useOrpc } from './useClient'
import { logError } from '@/utils/errorUtils'

export function useTefcaRetrySearch() {
  const orpc = useOrpc()

  return useMutation(
    orpc.tefcaRetrySearch.mutationOptions({
      onError: (error) => {
        logError('patient', 'TEFCA retry search', error)
        showNotification({ color: 'red', message: 'TEFCA search failed. Please try again.' })
      },
    }),
  )
}
